import { render, staticRenderFns } from "./MyClass.vue?vue&type=template&id=66c23410&scoped=true&"
import script from "./MyClass.vue?vue&type=script&lang=js&"
export * from "./MyClass.vue?vue&type=script&lang=js&"
import style0 from "./MyClass.vue?vue&type=style&index=0&id=66c23410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c23410",
  null
  
)

export default component.exports